import { useToast } from '@chakra-ui/react';

import type { UseToastOptions } from '@chakra-ui/react';

// A hook that wraps the toast/notification functionality.
export const useNotification = (hookOptions?: UseToastOptions) => {
  const toast = useToast();

  const notify = (toastOptions?: UseToastOptions) => {
    const isErrorStatus = toastOptions?.status === 'error' || hookOptions?.status === 'error';

    const options = {
      duration: isErrorStatus ? null : 3000,
      isClosable: true,
      ...hookOptions,
      ...toastOptions,
    };

    toast({ ...options });
  };

  return notify;
};
